/** @format */

import type { ErrorComponentProps } from "@tanstack/react-router";

import ErrorBoundary from "./ErrorBoundary";

/** Shared error component for TanStack Router routes. */
export function RouteErrorComponent({ error, info, reset }: ErrorComponentProps) {
  return (
    <ErrorBoundary
      error={error}
      componentStack={info?.componentStack}
      resetError={reset}
    />
  );
}
